import {AutogenLayoutMovementQuickInfo} from "./autogen/AutogenLayoutMovementQuickInfo";
import { DataSourceExecutionEvent } from "@mcleod/components";


export class MovementQuickInfo extends AutogenLayoutMovementQuickInfo {


    /** This is an event handler for the afterExecution event of sourceMovementStops. */
    sourceMovementStopsAfterExecution(event: DataSourceExecutionEvent) {
        if (!(event.data?.data)) {
            this.labelError.visible = true;
            this.panelMovementQuickInfo.visible = false;
        }
    }
}
